/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'

import '@quasar/extras/roboto-font/roboto-font.css'



import '@quasar/extras/animate/swing.css'

import '@quasar/extras/animate/bounceIn.css'

import '@quasar/extras/animate/bounceOut.css'

import '@quasar/extras/animate/slideInRight.css'

import '@quasar/extras/animate/slideOutRight.css'

import '@quasar/extras/animate/slideInLeft.css'

import '@quasar/extras/animate/slideOutLeft.css'


// We load Quasar stylesheet file
import 'quasar/dist/quasar.styl'




import 'src/css/app.styl'


import Vue from 'vue'
import createApp from './app.js'


import 'app/src-pwa/register-service-worker.js'




import qboot_Bootfirebase from 'boot/firebase'

import qboot_Bootlodash from 'boot/lodash'

import qboot_BootappUtils from 'boot/appUtils'

import qboot_BootvueGoogleMaps from 'boot/vueGoogleMaps'

import qboot_BootvueGridLayout from 'boot/vueGridLayout'







Vue.config.devtools = true
Vue.config.productionTip = false





// Needed only for iOS PWAs
if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && window.navigator.standalone) {
  import(/* webpackChunkName: "fastclick"  */ '@quasar/fastclick')
}


const publicPath = ``


async function start () {
  const { app, store, router } = await createApp()

  

  
  let hasRedirected = false
  const redirect = url => {
    hasRedirected = true
    const normalized = Object(url) === url
      ? router.resolve(url).route.fullPath
      : url

    window.location.href = normalized
  }

  const urlPath = window.location.href.replace(window.location.origin, '')
  const bootFiles = [qboot_Bootfirebase,qboot_Bootlodash,qboot_BootappUtils,qboot_BootvueGoogleMaps,qboot_BootvueGridLayout]

  for (let i = 0; hasRedirected === false && i < bootFiles.length; i++) {
    if (typeof bootFiles[i] !== 'function') {
      continue
    }

    try {
      await bootFiles[i]({
        app,
        router,
        store,
        Vue,
        ssrContext: null,
        redirect,
        urlPath,
        publicPath
      })
    }
    catch (err) {
      if (err && err.url) {
        window.location.href = err.url
        return
      }

      console.error('[Quasar] boot error:', err)
      return
    }
  }

  if (hasRedirected === true) {
    return
  }
  

  

    

    

    
      new Vue(app)
    

    

    

  

}

start()
